import { IconButton } from "@circleco/compass/components/IconButton";
import { useShallow } from "zustand/react/shallow";

import { t } from "@/i18n-js/instance";

import { DOM_IDS } from "./Layout/defaults";
import { useCircleAIShellStore } from "./store/circleAIShellStore";

export const PanelTriggerButton = () => {
  const { toggleRightSidebarVisible, isRightSidebarVisible } =
    useCircleAIShellStore(
      useShallow(s => ({
        toggleRightSidebarVisible: s.toggleRightSidebarVisible,
        isRightSidebarVisible: s.isRightSidebarVisible,
      })),
    );
  const ariaLabel = t("circle_ai_shell.toggle_panel");

  return (
    <IconButton
      icon="layout-sidebar"
      size="sm"
      variant="outline"
      onClick={toggleRightSidebarVisible}
      title={ariaLabel}
      aria-label={ariaLabel}
      aria-expanded={isRightSidebarVisible}
      aria-controls={DOM_IDS.communityRightSidebarBody}
      data-testid="circle-ai-shell-panel-trigger"
    />
  );
};

PanelTriggerButton.displayName = "CircleAIAppShell.PanelTriggerButton";
